import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Frontend mock logic
    setTimeout(() => {
      setLoading(false);
      setToastMessage({ type: 'success', text: 'Reset link sent to your email!' });
      
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    }, 1000);
  };

  return (
    <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'radial-gradient(ellipse at 20% 50%, rgba(212,175,55,0.06) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(212,175,55,0.04) 0%, transparent 50%), #0a0a0a',
        padding: '1rem', position: 'relative', overflow: 'hidden'
    }}>
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, background: 'radial-gradient(ellipse 600px 400px at 50% 40%, rgba(212,175,55,0.05), transparent)' }} />

      <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}>🔐</div>
          <h1 style={{ fontSize: '2rem', fontWeight: 900, letterSpacing: '0.15em', background: 'linear-gradient(135deg, #E8B84B 0%, #FFD26E 50%, #B8923A 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '0.25rem' }}>Ananda Marga</h1>
          <p style={{ color: '#666', fontSize: '0.75rem', letterSpacing: '0.2em', textTransform: 'uppercase' }}>Password Recovery</p>
        </div>

        {toastMessage && (
          <div style={{
            background: toastMessage.type === 'success' ? 'rgba(34, 197, 94, 0.1)' : 'rgba(248, 68, 68, 0.1)',
            border: `1px solid ${toastMessage.type === 'success' ? 'rgba(34, 197, 94, 0.3)' : 'rgba(248, 68, 68, 0.3)'}`,
            borderRadius: '0.5rem', padding: '1rem', color: toastMessage.type === 'success' ? '#4ade80' : '#f87171',
            marginBottom: '1.5rem', textAlign: 'center', fontSize: '0.9rem'
          }}>
            {toastMessage.text}
          </div>
        )}

        <div className="glass-card" style={{ padding: '2rem', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(212,175,55,0.1)', borderRadius: '1rem', backdropFilter: 'blur(10px)' }}>
          <h2 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#fff', marginBottom: '0.25rem' }}>Reset Password</h2>
          <p style={{ color: '#666', fontSize: '0.8rem', marginBottom: '1.75rem', lineHeight: '1.5' }}>
            Enter your registered email address and we'll send you a link to reset your password.
          </p>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.4rem', color: '#E8B84B', fontSize: '0.85rem' }}>Email Address</label>
              <input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} required disabled={loading}
                style={{ width: '100%', padding: '0.75rem', background: '#1a1a1a', border: '1px solid #333', borderRadius: '0.5rem', color: '#fff' }}
              />
            </div>

            <button type="submit" disabled={loading} style={{ marginTop: '0.25rem', width: '100%', padding: '0.75rem', background: 'linear-gradient(90deg, #E8B84B, #B8923A)', border: 'none', borderRadius: '0.5rem', color: '#000', fontWeight: 'bold', cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div style={{ textAlign: 'center', marginTop: '1rem' }}>
              <a href="/login" onClick={(e) => { e.preventDefault(); navigate('/login'); }} style={{ color: '#666', fontSize: '0.8rem', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={(e) => e.target.style.color = '#E8B84B'} onMouseOut={(e) => e.target.style.color = '#666'}>
                ← Back to Login
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
